module.exports = "d67bb657dbd601b4eae960f6753d17ca.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/temple-roof-edge-L.png
// module id = 48
// module chunks = 0